import APImage from './APImage';

export {
    APImage
};

export default APImage;